<button
  type="button"
  class="player-time-control__live sn-player__button"
  [class.player-time-control__live_active]="live$ | async"
  (click)="toggle()"
>
  {{ 'cameras.stream.live' | t }}
</button>
